/**
 * Created by andrey on 25.07.17.
 */

const LanguagesWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this._super({
            title: Messages.get("Language"),
            name: "languageswindow",
            content: this.createContent() 
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.LanguagesWindow;

        let columns = 3;
        if (cleverapps.resolution.isVertical()) {
            columns = 2;
        }

        this.buttonsPerLanguage = {};

        const buttons = cleverapps.config.languages.map(function (language) {
            const button = new LanguageButton(language, this.buttonClicked.bind(this));
            this.buttonsPerLanguage[language] = button;
            return button;
        }, this);

        return new cleverapps.GridLayout(buttons, {
            columns,
            margin: {
                x: styles.margin,
                y: styles.margin
            }
        });
    },

    buttonClicked: function (language) {
        const currentLanguage = cleverapps.settings.language;

        if (language !== currentLanguage) {
            cleverapps.focusManager.display({
                focus: "LanguageChanged",
                stack: true,
                action: (f) => {
                    cleverapps.settings.setLanguage(language);
                    cleverapps.settings.updateDependents();

                    this.buttonsPerLanguage[currentLanguage].updateEnabled();

                    this.close();

                    Messages.loadLanguage(language, () => {
                        this.setTitle(Messages.get("Language"));

                        if (cleverapps.environment.isGameScene() && !["merge", "merge2"].includes(cleverapps.config.type)) {
                            if (!cleverapps.lives) {
                                Level.WantsToPlay(f, {
                                    interstitial: false
                                });
                            } else {
                                f();
                            }
                        } else {
                            cleverapps.meta.gotoMainLocation(f);
                        }
                    });
                }
            });
        }
    },

    listBundles: function () { 
        return ["languages_window"];
    }
});

cleverapps.styles.LanguagesWindow = {
    margin: 20
};